// Sonave – mode showcase: pill switcher, arrows and swipe between the modes. Effects play only
// while the section is on screen; the optional auto-advance stops once the visitor picks a mode.
if (!customElements.get('glow-mode-showcase')) {
  customElements.define(
    'glow-mode-showcase',
    class GlowModeShowcase extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.glow-modeshow__slide'));
        this.tabs = Array.from(this.querySelectorAll('.glow-modeshow__tab'));
        this.index = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduceMotion && !this.designMode;
        if (this.slides.length < 2) {
          this.classList.add('is-visible');
          return;
        }

        this.tabs.forEach((tab) =>
          tab.addEventListener('click', () => this.pick(Number(tab.dataset.index)))
        );
        this.querySelector('[role="tablist"]').addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.pick(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.tabs[this.index].focus();
        });
        this.querySelectorAll('[data-step]').forEach((button) =>
          button.addEventListener('click', () => this.pick(this.index + Number(button.dataset.step)))
        );

        // Swipe on phones: a mostly horizontal drag of 40 px or more changes the mode
        this.addEventListener(
          'pointerdown',
          (event) => {
            if (event.pointerType === 'mouse' || event.target.closest('button')) return;
            this.startX = event.clientX;
            this.startY = event.clientY;
          },
          { passive: true }
        );
        this.addEventListener(
          'pointerup',
          (event) => {
            if (this.startX == null) return;
            const dx = event.clientX - this.startX;
            const dy = event.clientY - this.startY;
            this.startX = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.pick(this.index + (dx < 0 ? 1 : -1));
          },
          { passive: true }
        );

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.classList.toggle('is-visible', entry.isIntersecting);
              if (entry.isIntersecting) this.startTimer();
              else this.stopTimer();
            },
            { threshold: 0.25 }
          );
          this.observer.observe(this);
        } else {
          this.classList.add('is-visible');
        }

        if (this.designMode) {
          document.addEventListener('shopify:block:select', (event) => {
            const i = this.tabs.indexOf(event.target);
            if (i > -1) this.go(i);
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.stopTimer();
      }

      pick(index) {
        this.autoplay = false;
        this.stopTimer();
        this.go(index);
      }

      go(index) {
        const count = this.slides.length;
        this.index = ((index % count) + count) % count;
        this.slides.forEach((slide, i) => {
          const on = i === this.index;
          slide.classList.toggle('is-active', on);
          slide.toggleAttribute('aria-hidden', !on);
        });
        this.tabs.forEach((tab, i) => {
          const on = i === this.index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          // keep the chosen pill in view inside the switcher without scrolling the page
          if (on) tab.parentElement.scrollTo({ left: tab.offsetLeft - tab.parentElement.clientWidth / 2 + tab.offsetWidth / 2, behavior: 'smooth' });
        });
      }

      startTimer() {
        if (!this.autoplay || this.timer) return;
        this.timer = setInterval(() => this.go(this.index + 1), 6000);
      }

      stopTimer() {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  );
}
